import { forwardRef, type SVGAttributes } from 'react';

const RightArrow = forwardRef<SVGSVGElement, SVGAttributes<SVGSVGElement>>(
  ({ className, fill = 'black', ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={10}
        height={10}
        fill={fill}
        ref={ref}
        className={className}
        {...props}
      >
        <path
          fill={fill}
          fillRule="evenodd"
          d="M7.586 5.5 4.439 8.646l.707.708L9.5 5 5.146.646l-.707.708L7.586 4.5H.293v1h7.293Z"
          clipRule="evenodd"
        />
      </svg>
    );
  }
);
RightArrow.displayName = 'RightArrow';
export default RightArrow;
